import React, { useEffect, useState } from "react";

export default function ActionForm(item) {
    const [openForm, setOpenForm] = useState(false)


    return (<div className="btn-action-group text-right">
        <button type="button" className="btn btn-sm" onClick={()=>setOpenForm(!openForm)}>
            <span className="fas fa-ellipsis-v"></span>
        </button>
        {openForm &&
            <div className="w-100">
                <button type="button" className="btn btn-sm btn-warning w-100"><span className="fas fa-pencil-alt"></span> Sửa</button>
                <button type="button" className="btn btn-sm btn-danger w-100 mt-1"><span className="fas fa-trash-alt"></span> Xóa</button>
            </div>
        }

    </div>)
}